/// <reference path="../app.ts" />
namespace Cfnc {
    export interface ITranscriptDataService {
        requestTranscript: (TranscriptRequest) => ng.IPromise<any>;
        getParticipatingApplications: () => ng.IPromise<any>;
        getSubmittedTranscripts: () => ng.IPromise<any>;
    }

    export class TranscriptRequest {
        userId: number;
        applicationIds: Array<string>;
        ceeb: string;
    }

    export class TranscriptDataService implements ITranscriptDataService {
        static serviceId: string = "transcriptDataService";

        constructor(private common: ICommonFactory, private $http: ng.IHttpService, private Restangular: Restangular.IService) {
        }

        requestTranscript = (transcriptRequest: TranscriptRequest) => {
            var deferred = this.common.$q.defer();
            this.Restangular.all("transcripts/sendtranscript").post(transcriptRequest).then((result) => {
                deferred.resolve(result);
            },(reason) => {
                    deferred.reject(reason);
                });

            return deferred.promise;
        };

        getParticipatingApplications = () => {
            var deferred = this.common.$q.defer();
            this.Restangular.all("transcripts/participatingapplications").getList()
                .then((result) => {
                deferred.resolve(result);
            },
                (reason) => {
                    deferred.reject(reason);
                });
            return deferred.promise;
        };

        getSubmittedTranscripts = () => {
            var deferred = this.common.$q.defer();
            this.Restangular.all("transcripts").getList()
                .then((result) => {
                deferred.resolve(result);
            },(reason) => {
                    deferred.reject(reason);
                });
            return deferred.promise;
        };


    }

    angular.module("app").factory(TranscriptDataService.serviceId, ["common", "$http", "Restangular", (common: ICommonFactory, $http: ng.IHttpService, Restangular) =>
        new TranscriptDataService(common, $http, Restangular)
    ]);
}